var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"collapsible":"","collapsed":"","info-mode":"","title":_vm.sectionTitle,"help-collapsed":_vm.sectionHelpCollapsed,"help-expanded":_vm.sectionHelpExpanded}},[_c('kst-number-with-date',{attrs:{"view-mode":"","catalog":_vm.Catalog,"data":_vm.userData,"dateField":"SalesOrderDate","numberField":"SONumber"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }